export default function FilterCheckbox({ label, checked, onChange }) {
  return (
    <label className="flex cursor-pointer items-center gap-3 rounded-xl px-2 py-2 text-sm text-muted-foreground transition hover:bg-neutral-100 hover:text-foreground">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="size-4 rounded border-border text-foreground focus:ring-ring"
      />
      {label}
    </label>
  );
}